module.exports = __webpack_public_path__ + "img/nummius_cointreasure.cd469f8.png";